import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FiShoppingCart,
  FiArrowLeft,
  FiShoppingBag,
  FiTrash2,
  FiHeart,
  FiTag,
  FiPackage,
  FiMinus,
  FiPlus,
  FiHome,
  FiX,
  FiMapPin,
  FiCreditCard,
  FiUser,
  FiPhone,
  FiMail,
  FiChevronRight,
  FiChevronLeft,
  FiCheckCircle,
  FiAlertTriangle,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import UserMasterLayout from "../../layouts/CustomerMasterLayout";
import Button from "../../components/general/button/Button";
import "../../assets/css/customer/customerDashboard/customerCart/CustomerCart.css";
import Autocomplete from "react-google-autocomplete";
import MyContext from "../../context/MyContext";
import { CartPageSkeleton } from "../../components/general/skeleton/SkeletonBlock";

// ── Pakistan Cities — alphabetically sorted ──
const Google_Api_Key = "AIzaSyAsHyOeJMDU6y5kDiiJQlLFBAcp9S6rTMA";
const PAKISTAN_CITIES = [
  "Abbottabad", "Attock", "Bahawalpur", "Bahawalnagar", "Burewala", "Chakwal",
  "Chiniot", "Chishtian", "Daska", "Dera Ghazi Khan", "Dera Ismail Khan",
  "Faisalabad", "Ghotki", "Gujranwala", "Gujrat", "Hafizabad", "Haripur",
  "Hyderabad", "Islamabad", "Jacobabad", "Jhelum", "Kamoke", "Karachi",
  "Kasur", "Khanewal", "Khushab", "Khuzdar", "Lahore", "Larkana", "Layyah",
  "Lodhran", "Mailsi", "Mansehra", "Mardan", "Mianwali", "Mirpur Khas",
  "Multan", "Muridke", "Muzaffarabad", "Muzaffargarh", "Narowal", "Nawabshah",
  "Nowshera", "Okara", "Pakpattan", "Peshawar", "Quetta", "Rahim Yar Khan",
  "Rawalpindi", "Sadiqabad", "Sahiwal", "Sargodha", "Sheikhupura", "Sialkot",
  "Sukkur", "Swabi", "Swat", "Toba Tek Singh", "Vehari", "Wah Cantonment",
  "Wazirabad",
].sort();

const CustomerCart = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles, loggedInCustomer, authToken } = useContext(MyContext);

  const [cartProducts, setCartProducts] = useState([]);
  const [visibleItems, setVisibleItems] = useState({});
  const itemRefs = useRef({});

  const [subtotal, setSubtotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [cartCount, setCartCount] = useState(0);
  const [editingQuantities, setEditingQuantities] = useState({});

  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [isEmptyVisible, setIsEmptyVisible] = useState(false);
  const [isSummaryVisible, setIsSummaryVisible] = useState(false);
  const emptyRef = useRef(null);
  const summaryRef = useRef(null);

  /* ── Checkout Modal States ── */
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [checkoutStep, setCheckoutStep] = useState(1);
  const [kmsellerId, setKmsellerId] = useState(null);
  const [paymentType] = useState("online");
  const [shippingAddress, setShippingAddress] = useState("");
  const [shippingLat, setShippingLat] = useState(null);
  const [shippingLng, setShippingLng] = useState(null);
  const [orderStatus] = useState("pending");

  /* ── Intercity Bulk Delivery — eligibility check state ── */
  const [bulkChecking, setBulkChecking] = useState(false);
  const [orderType, setOrderType] = useState("same_city");

  /* ── Order placement loading state ── */
  const [stripeLoading, setStripeLoading] = useState(false);

  /* ── New States ── */
  const [phone, setPhone] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [citySearch, setCitySearch] = useState("");
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const cityDropdownRef = useRef(null);

  const filteredCities = PAKISTAN_CITIES.filter((c) =>
    c.toLowerCase().includes(citySearch.toLowerCase()),
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        cityDropdownRef.current &&
        !cityDropdownRef.current.contains(e.target)
      ) {
        setShowCityDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const hasOutOfStockItem = cartProducts.some(
    (item) => Number(item.kmproduct?.stock) <= 0,
  );

 

  const openCheckout = () => {
    const outOfStockItem = cartProducts.find(
      (item) => Number(item.kmproduct?.stock) <= 0,
    );
    if (outOfStockItem) {
      Swal.fire({
        icon: "warning",
        title: "Out of Stock Item",
        text: `${outOfStockItem.kmproduct?.name} out of stock hai. Checkout se pehle isay cart se remove karain.`,
      });
      return;
    }

    setPhone(loggedInCustomer?.phone || "");
    setCheckoutStep(1);
    setShowCheckoutModal(true);
  };

  const closeCheckout = () => {
    setShowCheckoutModal(false);
    setCheckoutStep(1);
    setSelectedCity("");
    setCitySearch("");
    setShippingAddress("");
    setShippingLat(null);
    setShippingLng(null);
    setDiscount(0);
    setGrandTotal(subtotal);
    setOrderType("same_city");
  };

  useEffect(() => {
    if (cartProducts.length === 0) return;
    const observers = [];
    cartProducts.forEach((item) => {
      const el = itemRefs.current[item.id];
      if (!el) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setVisibleItems((prev) => ({ ...prev, [item.id]: true }));
            observer.unobserve(entry.target);
          }
        },
        { threshold: 0.1 },
      );
      observer.observe(el);
      observers.push(observer);
    });
    return () => observers.forEach((o) => o.disconnect());
  }, [cartProducts]);

  const viewAllCartProducts = () => {
    if (!authToken) {
      setLoading(false);
      navigate("/customer/login");
      return;
    }
    if (!loggedInCustomer?.id) {
      setLoading(false);
      navigate("/customer/login");
      return;
    }
    const formData = new FormData();
    setLoading(true);
    axios
      .post(`${baseUrl}/customer/cart/viewAllCartProducts`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.hasOwnProperty("error")) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          const items = response.data.cartProducts;
          setCartProducts(items);
          setCartCount(items.length);
          const sub = items.reduce(
            (sum, i) => sum + Number(i.total_price || 0),
            0,
          );
          setSubtotal(sub);
          setGrandTotal(sub);
          if (items.length > 0) setKmsellerId(items[0].kmproduct?.kmseller?.id);
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 401) {
          navigate("/customer/login");
          return;
        }
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load cart products.",
        });
      });
  };

  const removeProductFromCart = (idToRemoveProduct) => {
    const formData = new FormData();
    formData.append("id", idToRemoveProduct);
    axios
      .post(`${baseUrl}/customer/cart/removeProductFromCart`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data.hasOwnProperty("error")) {
          setErrorMessage(response.data.error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Removed!",
            text: "Product removed successfully!",
          });
          viewAllCartProducts();
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          navigate("/customer/login");
          return;
        }
        Swal.fire({ icon: "error", title: "Error", text: "Failed to remove." });
      });
  };

  const updateCartQuantity = (cartItemId, newQuantity) => {
    const formData = new FormData();
    formData.append("id", cartItemId);
    formData.append("quantity", newQuantity);

    axios
      .post(`${baseUrl}/customer/cart/updateCartQuantity`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data.hasOwnProperty("error") || response.data.success === false) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error || response.data.message,
          });
        } else {
          viewAllCartProducts();
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          navigate("/customer/login");
          return;
        }
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update quantity.",
        });
      });
  };

  /* ══════════════════════════════════════════════════════════
     ── checkBulkEligibilityAndProceed — Intercity Bulk Delivery spec.
        Address/city submit hote hi ye call hoti hai, order summary
        se PEHLE. Agar intercity order hai aur quantity threshold se
        kam hai to block kar deta hai, sahi wajah ke sath. Eligible
        ho to discount apply kar ke step 2 pe le jata hai.
  ══════════════════════════════════════════════════════════ */
  const checkBulkEligibilityAndProceed = () => {
    setBulkChecking(true);
    const formData = new FormData();
    formData.append("kmseller_id", kmsellerId);
    formData.append("shippingCity", selectedCity);

    axios
      .post(`${baseUrl}/customer/order/checkBulkEligibility`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        setBulkChecking(false);

        if (response.data.hasOwnProperty("error") || response.data.success === false) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error || "Could not check delivery eligibility.",
          });
          return;
        }

        setOrderType(response.data.order_type);

        if (!response.data.eligible) {
          const blocked = response.data.blocked_items?.[0];
          Swal.fire({
            icon: "warning",
            title: "Minimum Quantity Required",
            text: response.data.message,
            showCancelButton: true,
            confirmButtonText: blocked?.remaining
              ? `Add ${blocked.remaining} more to cart`
              : "Go back to cart",
            cancelButtonText: "Go back to cart",
            confirmButtonColor: "#097d43",
          }).then((result) => {
            if (result.isConfirmed && blocked?.remaining && blocked?.kmproduct_id) {
              const cartItem = cartProducts.find(
                (c) => c.kmproduct_id === blocked.kmproduct_id
              );
              if (cartItem) {
                updateCartQuantity(cartItem.id, blocked.required);
              }
            }
            closeCheckout();
          });
          return;
        }

        const discountAmount = response.data.total_discount_amount || 0;
        setDiscount(discountAmount);
        setGrandTotal(subtotal - discountAmount);
        setCheckoutStep(2);
      })
      .catch((error) => {
        setBulkChecking(false);
        if (error.response?.status === 401) {
          navigate("/customer/login");
          return;
        }
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Could not check delivery eligibility. Please try again.",
        });
      });
  };

  /* ══════════════════════════════════════════════════════════
     ── placeOrder — createOrder API hi call hoti hai. Ab yahan
        payment NAHI hoti — order create hote hi delivery job
        "open" ho jati hai bidding ke liye. Payment sirf tab
        hogi jab customer kisi driver ka bid select karega
        (OrderDetails.jsx mein selectDriverBid se).
  ══════════════════════════════════════════════════════════ */
  const placeOrder = () => {
    if (!shippingAddress) {
      Swal.fire({
        icon: "warning",
        title: "Address Required",
        text: "Please enter shipping address!",
      });
      return;
    }

    const fullAddress = `${selectedCity}, ${shippingAddress}`;

    setStripeLoading(true);
    const formData = new FormData();
    formData.append("kmseller_id", kmsellerId);
    formData.append("paymentType", paymentType);
    formData.append("phone", phone);
    formData.append("shippingAddress", fullAddress);
    formData.append("shippingCity", selectedCity);
    formData.append("shippingLat", shippingLat);
    formData.append("shippingLng", shippingLng);
    formData.append("subTotal", subtotal);
    formData.append("discount", discount);
    formData.append("totalPrice", grandTotal);
    formData.append("status", orderStatus);

    axios
      .post(`${baseUrl}/customer/order/createOrder`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        setStripeLoading(false);
        if (response.data.hasOwnProperty("error") || response.data.success === false) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error || response.data.message || "Failed to place order.",
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Order Placed!",
            text: "Waiting for delivery drivers to bid on your order.",
            confirmButtonColor: "#097d43",
          }).then(() => {
            localStorage.setItem("pendingOrderBidsId", response.data.order_id);
            console.log(response.data);
            navigate("/customer/order-bids", {
              state: {
                kmorder_id: response.data.order_id,
              },
            });
          });
        }
      })
      .catch((error) => {
        setStripeLoading(false);
        if (error.response?.status === 401) {
          navigate("/customer/login");
          return;
        }
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to place order.",
        });
      });
  };

  const addProductToWishlist = (productId) => {
    const formData = new FormData();
    formData.append("kmproduct_id", productId);
    axios
      .post(`${baseUrl}/customer/wishlist/addProductToWishlist`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data.hasOwnProperty("error")) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Product added to wishlist!",
          });
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          navigate("/customer/login");
          return;
        }
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to add in Wishlist",
        });
      });
  };

  useEffect(() => {
    viewAllCartProducts();
  }, [loggedInCustomer, authToken]);

  useEffect(() => {
    if (!loading && cartProducts.length === 0 && emptyRef.current) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsEmptyVisible(true);
            observer.unobserve(entry.target);
          }
        },
        { threshold: 0.1 },
      );
      observer.observe(emptyRef.current);
      return () => observer.disconnect();
    }
  }, [cartProducts.length, loading]);

  useEffect(() => {
    if (summaryRef.current && cartProducts.length > 0) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsSummaryVisible(true);
            observer.unobserve(entry.target);
          }
        },
        { threshold: 0.1 },
      );
      observer.observe(summaryRef.current);
      return () => observer.disconnect();
    }
  }, [cartProducts.length]);

  /* ══════════════════════════════════════════════════════════
     RENDER
  ══════════════════════════════════════════════════════════ */
  if (loading) {
    return (
      <UserMasterLayout>
        <CartPageSkeleton />
      </UserMasterLayout>
    );
  }

  return (
    <UserMasterLayout>
      <Container fluid className="cart-container">
        {/* Cart Header */}
        <div className="cart-header">
          <div className="cart-header-left">
            <div className="cart-icon-wrapper">
              <FiShoppingCart size={28} />
            </div>
            <div>
              <h2 className="cart-page-title">My Cart</h2>
              <p className="cart-subtitle">
                {cartCount} {cartCount === 1 ? "item" : "items"} in your cart
              </p>
            </div>
          </div>
          {cartProducts.length > 0 && (
            <div>
              <Button
                className="outline-gradient"
                variant="secondary"
                size="small"
                icon={<FiArrowLeft />}
                iconPosition="left"
                onClick={() => navigate("/products")}
              >
                Continue Shopping
              </Button>
            </div>
          )}
        </div>

        {/* Main Content */}
        {cartProducts.length === 0 ? (
          <div
            ref={emptyRef}
            className={`empty-cart ${isEmptyVisible ? "animate-in" : ""}`}
          >
            <div className="empty-cart-icon">
              <FiShoppingBag />
            </div>
            <h2 className="empty-cart-title">Your Cart is Empty</h2>
            <p className="empty-cart-text">
              Looks like you haven't added anything to your cart yet.
              <br />
              Start shopping now!
            </p>
            <Button
              className="outline-gradient"
              variant="primary"
              size="medium"
              icon={<FiShoppingCart />}
              iconPosition="left"
              onClick={() => navigate("/products")}
            >
              Continue Shopping
            </Button>
          </div>
        ) : (
          <Row className="g-4">
            {/* Cart Items */}
            <Col xs={12} lg={8}>
              {cartProducts.map((item, index) => {
                const isOutOfStock = Number(item.kmproduct?.stock) <= 0;
                const minQty = item.kmproduct?.min_order_quantity || 1;
                

                return (
                  <div
                    key={item.id}
                    ref={(el) => (itemRefs.current[item.id] = el)}
                    className={`cart-item-card ${visibleItems[item.id] ? "animate-in" : ""} ${isOutOfStock ? "cart-item-out-of-stock" : ""}`}
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="cart-item-content">
                      <div
                        className="cart-item-image"
                        style={{ position: "relative" }}
                      >
                        <img
                          src={`${baseUrlForFiles}/${item.kmproduct?.image}`}
                          alt={item.kmproduct?.name}
                          style={
                            isOutOfStock
                              ? { filter: "grayscale(70%)", opacity: 0.6 }
                              : {}
                          }
                        />
                        {isOutOfStock && (
                          <span
                            style={{
                              position: "absolute",
                              top: 6,
                              left: 6,
                              background: "#d33",
                              color: "#fff",
                              fontSize: 10,
                              fontWeight: 600,
                              padding: "3px 6px",
                              borderRadius: 5,
                            }}
                          >
                            Out of Stock
                          </span>
                        )}
                      </div>
                      <div className="cart-item-details">
                        <h3 className="cart-item-name">{item.kmproduct?.name}</h3>
                        {item.kmproduct?.kmseller?.shopname && (
                          <div className="cart-item-shop">
                            <FiHome size={14} />{" "}
                            {item.kmproduct?.kmseller?.shopname}
                          </div>
                        )}
                        <div className="cart-item-meta">
                          <span className="cart-item-category">
                            <FiTag size={14} />
                            {
                              item.kmproduct?.kmsubcategory?.kmcategory
                                ?.categoryname
                            }
                          </span>
                          <div className="cart-item-weight">
                            <FiPackage size={14} />
                            Quantity: {item.quantity}
                          </div>
                        </div>
                        <div style={{ fontSize: 11, color: "#888" }}>
                          Min Order: {minQty}
        
                        </div>
                        <div className="cart-item-price-section">
                          <span className="cart-item-price">
                            Rs. {item.amountPerPiece?.toLocaleString()}
                            {item.kmproduct?.unit && ` / ${item.kmproduct?.unit}`}
                          </span>
                        </div>
                        <div className="cart-item-total">
                          <strong>
                            Item Total: Rs. {item.total_price?.toLocaleString()}
                          </strong>
                        </div>
                      </div>
                      <div className="cart-item-actions">
                        <div className="quantity-control">
                          <button
                            className="quantity-btn"
                            onClick={() => {
                              if (item.quantity > minQty) {
                                updateCartQuantity(item.id, item.quantity - 1);
                              }
                            }}
                            disabled={isOutOfStock || item.quantity <= minQty}
                            style={
                              isOutOfStock || item.quantity <= minQty
                                ? { cursor: "not-allowed", opacity: 0.5 }
                                : {}
                            }
                          >
                            <FiMinus size={14} />
                          </button>

                          <input
                            type="number"
                            className="quantity-value-input"
                            min={minQty}
                            disabled={isOutOfStock}
                            value={
                              editingQuantities.hasOwnProperty(item.id)
                                ? editingQuantities[item.id]
                                : item.quantity
                            }
                            onChange={(e) =>
                              setEditingQuantities((prev) => ({
                                ...prev,
                                [item.id]: e.target.value,
                              }))
                            }
                            onBlur={(e) => {
                              const val = parseInt(e.target.value);
                              if (
                                !isNaN(val) &&
                                val >= minQty &&
                                
                                val !== item.quantity
                              ) {
                                updateCartQuantity(item.id, val);
                              }
                              setEditingQuantities((prev) => {
                                const updated = { ...prev };
                                delete updated[item.id];
                                return updated;
                              });
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.target.blur();
                              }
                            }}
                          />

                          <button
                            className="quantity-btn"
                            disabled={isOutOfStock }
                            style={
                              isOutOfStock 
                                ? { cursor: "not-allowed", opacity: 0.5 }
                                : {}
                            }
                            onClick={() =>
                              updateCartQuantity(item.id, item.quantity + 1)
                            }
                          >
                            <FiPlus size={14} />
                          </button>
                        </div>
                        <button
                          className="outline-gradient"
                          onClick={() => addProductToWishlist(item.kmproduct_id)}
                        >
                          <FiHeart size={14} /> Save for Later
                        </button>
                        <button
                          className="remove-btn"
                          onClick={() => removeProductFromCart(item.id)}
                          title="Remove from cart"
                        >
                          <FiTrash2 size={14} />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Col>

            {/* Order Summary */}
            <Col xs={12} lg={4}>
              <div
                ref={summaryRef}
                className={`cart-summary-card ${isSummaryVisible ? "animate-in" : ""}`}
              >
                <h3 className="summary-title">Order Summary</h3>

                {hasOutOfStockItem && (
                  <div
                    style={{
                      background: "#fef2f2",
                      border: "1px solid #fca5a5",
                      color: "#b91c1c",
                      borderRadius: 8,
                      padding: "8px 12px",
                      fontSize: 12,
                      marginBottom: 12,
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <FiAlertTriangle size={14} />
                    Some items are out of stock. Please remove them to proceed to checkout.
                  </div>
                )}

                <div className="summary-row">
                  <span className="summary-label">Subtotal</span>
                  <span className="summary-value">
                    Rs. {subtotal.toLocaleString()}
                  </span>
                </div>
                {discount > 0 && (
                  <div className="summary-row">
                    <span className="summary-label">Discount</span>
                    <span className="summary-value discount-green">
                      - Rs. {discount.toLocaleString()}
                    </span>
                  </div>
                )}
                <hr className="summary-divider" />
                <div className="summary-total">
                  <span>Total</span>
                  <span className="summary-total-value">
                    Rs. {grandTotal.toLocaleString()}
                  </span>
                </div>
                <p className="km-delivery-cod-note">
                  Delivery fee is not included — you'll see driver quotes and pay them cash on delivery after choosing one.
                </p>
                <div className="summary-actions">
                  <Button
                    variant="gradient"
                    size="medium"
                    fullWidth={true}
                    icon={<FiShoppingCart />}
                    iconPosition="left"
                    onClick={openCheckout}
                    disabled={hasOutOfStockItem}
                    style={hasOutOfStockItem ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                  >
                    Proceed to Checkout
                  </Button>
                  <Button
                    className="outline-gradient mt-2"
                    variant="outline"
                    size="medium"
                    fullWidth={true}
                    onClick={() => navigate("/products")}
                  >
                    Continue Shopping
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </Container>

      {/* ══════════════════════════════════════════════════════════
          CHECKOUT MODAL
      ══════════════════════════════════════════════════════════ */}
      {showCheckoutModal && (
        <div className="ksa-modal-overlay" onClick={closeCheckout}>
          <div
            className="ksa-modal ksa-modal-md ksa-category-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="ksa-category-modal-header">
              <h3 className="ksa-category-modal-title">
                {checkoutStep === 1 ? (
                  <>
                    <FiUser className="me-2" /> Customer Details
                  </>
                ) : (
                  <>
                    <FiShoppingCart className="me-2" /> Order Summary
                  </>
                )}
              </h3>
              <button className="ksa-modal-close" onClick={closeCheckout}>
                <FiX size={18} />
              </button>
            </div>

            {/* Step Indicator */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "12px 24px 0",
              }}
            >
              {[1, 2].map((step, i) => (
                <React.Fragment key={step}>
                  <div
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      background: checkoutStep >= step ? "#097d43" : "#e0e0e0",
                      color: checkoutStep >= step ? "#fff" : "#999",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      fontSize: 13,
                      transition: "background 0.3s",
                    }}
                  >
                    {step}
                  </div>
                  {i === 0 && (
                    <div
                      style={{
                        flex: 1,
                        height: 3,
                        maxWidth: 80,
                        background: checkoutStep >= 2 ? "#097d43" : "#e0e0e0",
                        borderRadius: 4,
                        transition: "background 0.3s",
                      }}
                    />
                  )}
                </React.Fragment>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "4px 24px 0",
                fontSize: 11,
                color: "#888",
              }}
            >
              <span
                style={{
                  color: checkoutStep >= 1 ? "#097d43" : "#aaa",
                  fontWeight: checkoutStep === 1 ? 600 : 400,
                }}
              >
                Your Details
              </span>
              <span
                style={{
                  color: checkoutStep >= 2 ? "#097d43" : "#aaa",
                  fontWeight: checkoutStep === 2 ? 600 : 400,
                }}
              >
                Order Summary
              </span>
            </div>

            {/* Modal Body */}
            <div className="ksa-category-modal-body" style={{ marginTop: 12 }}>
              {/* ════ STEP 1 — Customer Details ════ */}
              {checkoutStep === 1 && (
                <>
                  {/* Full Name — disabled */}
                  <div className="ksa-category-form-group">
                    <label>
                      <FiUser size={14} className="me-1" /> Full Name
                    </label>
                    <input
                      type="text"
                      className="ksa-category-input"
                      value={loggedInCustomer?.name || ""}
                      disabled
                    />
                  </div>

                  {/* Email — disabled */}
                  <div className="ksa-category-form-group">
                    <label>
                      <FiMail size={14} className="me-1" /> Email
                    </label>
                    <input
                      type="text"
                      className="ksa-category-input"
                      value={loggedInCustomer?.email || ""}
                      disabled
                    />
                  </div>

                  {/* Phone — EDITABLE */}
                  <div className="ksa-category-form-group">
                    <label>
                      <FiPhone size={14} className="me-1" /> Phone
                    </label>
                    <input
                      type="tel"
                      className="ksa-category-input"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="03XX-XXXXXXX"
                    />
                  </div>

                  {/* City — Searchable Dropdown */}
                  <div
                    className="ksa-category-form-group"
                    ref={cityDropdownRef}
                    style={{ position: "relative" }}
                  >
                    <label>
                      <FiMapPin size={14} className="me-1" /> City *
                    </label>
                    <input
                      type="text"
                      className="ksa-category-input"
                      placeholder="Search city..."
                      value={selectedCity ? selectedCity : citySearch}
                      onChange={(e) => {
                        setCitySearch(e.target.value);
                        setSelectedCity("");
                        setShippingAddress("");
                        setShowCityDropdown(true);
                      }}
                      onFocus={() => setShowCityDropdown(true)}
                      autoComplete="off"
                    />
                    {showCityDropdown && filteredCities.length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          background: "#fff",
                          border: "1px solid #dee2e6",
                          borderRadius: 8,
                          boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                          zIndex: 9999,
                          maxHeight: 200,
                          overflowY: "auto",
                        }}
                      >
                        {filteredCities.map((city) => (
                          <div
                            key={city}
                            onClick={() => {
                              setSelectedCity(city);
                              setCitySearch("");
                              setShowCityDropdown(false);
                            }}
                            style={{
                              padding: "9px 14px",
                              cursor: "pointer",
                              fontSize: 13,
                              fontFamily: "var(--font-body)",
                              color: "var(--text-dark)",
                              borderBottom: "1px solid #f5f5f5",
                              transition: "background 0.15s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.background = "#e8f5f0")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.background = "#fff")
                            }
                          >
                            {city}
                          </div>
                        ))}
                      </div>
                    )}
                    {showCityDropdown &&
                      filteredCities.length === 0 &&
                      citySearch && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            right: 0,
                            background: "#fff",
                            border: "1px solid #dee2e6",
                            borderRadius: 8,
                            padding: "10px 14px",
                            fontSize: 13,
                            color: "var(--text-muted)",
                            zIndex: 9999,
                          }}
                        >
                          No city found
                        </div>
                      )}
                  </div>

                  {/* Shipping Address — Google Autocomplete, enabled only if city selected */}
                  <div className="ksa-category-form-group">
                    <label>
                      <FiMapPin size={14} className="me-1" /> Shipping Address *
                    </label>
                    <Autocomplete
                      apiKey={Google_Api_Key}
                      className="ksa-category-input"
                      placeholder={
                        selectedCity
                          ? `Enter your address in ${selectedCity}...`
                          : "Please select a city first"
                      }
                      defaultValue={shippingAddress}
                      onChange={(e) => setShippingAddress(e.target.value)}
                      onPlaceSelected={(place) => {
                        if (!place) return;
                        setShippingAddress(
                          place?.formatted_address || place?.name || "",
                        );
                        setShippingLat(place?.geometry?.location?.lat());
                        setShippingLng(place?.geometry?.location?.lng());
                      }}
                      disabled={!selectedCity}
                      options={{
                        types: ["geocode"],
                        componentRestrictions: { country: "pk" },
                      }}
                      style={{
                        opacity: selectedCity ? 1 : 0.5,
                        cursor: selectedCity ? "text" : "not-allowed",
                      }}
                    />
                    {!selectedCity && (
                      <p
                        style={{
                          fontSize: 11,
                          color: "#f59e0b",
                          margin: "4px 0 0",
                          fontFamily: "var(--font-body)",
                        }}
                      >
                        ⚠️ Select a city to enter address
                      </p>
                    )}
                  </div>
                </>
              )}

              {/* ════ STEP 2 — Order Summary ════ */}
              {checkoutStep === 2 && (
                <>
                  {/* Delivering To */}
                  <div
                    style={{
                      background: "#f8fffe",
                      border: "1px solid #d0ebe0",
                      borderRadius: 8,
                      padding: "12px 16px",
                      marginBottom: 16,
                    }}
                  >
                    <p
                      style={{
                        fontWeight: 600,
                        color: "#097d43",
                        marginBottom: 8,
                        fontSize: 13,
                      }}
                    >
                      <FiUser size={13} className="me-1" /> Delivering To
                    </p>
                    <p style={{ margin: 0, fontSize: 13, color: "#333" }}>
                      {loggedInCustomer?.name}
                    </p>
                    <p style={{ margin: "2px 0", fontSize: 12, color: "#666" }}>
                      {loggedInCustomer?.email}
                    </p>
                    <p style={{ margin: "2px 0", fontSize: 12, color: "#666" }}>
                      <FiPhone size={11} className="me-1" />
                      {phone}
                    </p>
                    <p style={{ margin: "2px 0", fontSize: 12, color: "#666" }}>
                      <FiMapPin size={11} className="me-1" />
                      {selectedCity}, {shippingAddress}
                    </p>
                    <p
                      style={{ margin: "4px 0 0", fontSize: 12, color: "#666" }}
                    >
                      <FiCreditCard size={11} className="me-1" />
                      Product: Online (Card / Stripe) — Delivery: Cash on Delivery
                    </p>
                  </div>

                  {/* Items */}
                  <p
                    style={{
                      fontWeight: 600,
                      fontSize: 13,
                      color: "#333",
                      marginBottom: 8,
                    }}
                  >
                    <FiShoppingCart size={13} className="me-1" /> Items (
                    {cartCount})
                  </p>
                  <div
                    style={{
                      maxHeight: 160,
                      overflowY: "auto",
                      marginBottom: 16,
                    }}
                  >
                    {cartProducts.map((item) => (
                      <div
                        key={item.id}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "6px 0",
                          borderBottom: "1px solid #f0f0f0",
                          fontSize: 13,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <img
                            src={`${baseUrlForFiles}/${item.kmproduct?.image}`}
                            alt={item.kmproduct?.name}
                            style={{
                              width: 36,
                              height: 36,
                              objectFit: "cover",
                              borderRadius: 6,
                            }}
                          />
                          <div>
                            <div style={{ fontWeight: 500, color: "#222" }}>
                              {item.kmproduct?.name}
                            </div>
                            <div style={{ fontSize: 11, color: "#888" }}>
                              Qty: {item.quantity}
                            </div>
                          </div>
                        </div>
                        <span style={{ fontWeight: 600, color: "#097d43" }}>
                          Rs. {item.total_price?.toLocaleString()}
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* Pricing */}
                  <div className="ksa-category-form-group">
                    <label>Sub Total</label>
                    <input
                      type="text"
                      className="ksa-category-input"
                      value={`Rs. ${subtotal.toLocaleString()}`}
                      disabled
                    />
                  </div>

                  {discount > 0 && (
                    <div className="ksa-category-form-group">
                      <label>Bulk Discount</label>
                      <input
                        type="text"
                        className="ksa-category-input"
                        value={`- Rs. ${discount.toLocaleString()}`}
                        disabled
                        style={{ color: "#097d43" }}
                      />
                    </div>
                  )}

                  {/* City — shown after subtotal */}
                  <div className="ksa-category-form-group">
                    <label>
                      <FiMapPin size={14} className="me-1" /> City
                      {orderType === "intercity" && (
                        <span
                          style={{
                            marginLeft: 8,
                            fontSize: 11,
                            background: "#fff3cd",
                            color: "#856404",
                            padding: "2px 8px",
                            borderRadius: 10,
                          }}
                        >
                          Intercity Delivery
                        </span>
                      )}
                    </label>
                    <input
                      type="text"
                      className="ksa-category-input"
                      value={selectedCity}
                      disabled
                    />
                  </div>

                  <div className="ksa-category-form-group">
                    <label>Total Amount (Product Only)</label>
                    <input
                      type="text"
                      className="ksa-category-input"
                      value={`Rs. ${grandTotal.toLocaleString()}`}
                      disabled
                      style={{ fontWeight: "bold", color: "#097d43" }}
                    />
                  </div>

                  <p className="km-delivery-cod-note">
                    Delivery charge is not included here — after placing the order,
                    drivers will quote their price and you'll select one. That
                    amount is paid in cash directly to the driver on delivery.
                  </p>
                </>
              )}
            </div>

            {/* Modal Footer */}
            <div className="ksa-category-modal-footer">
              {checkoutStep === 1 ? (
                <>
                  <button className="outline-gradient" onClick={closeCheckout}>
                    Cancel
                  </button>
                  <Button
                    variant="gradient"
                    icon={<FiChevronRight />}
                    iconPosition="right"
                    disabled={bulkChecking}
                    onClick={() => {
                      if (!selectedCity) {
                        Swal.fire({
                          icon: "warning",
                          title: "City Required",
                          text: "Please select your city!",
                        });
                        return;
                      }
                      if (!shippingAddress.trim()) {
                        Swal.fire({
                          icon: "warning",
                          title: "Address Required",
                          text: "Please enter your shipping address!",
                        });
                        return;
                      }
                      checkBulkEligibilityAndProceed();
                    }}
                  >
                    {bulkChecking ? "Checking..." : "Next: Review Order"}
                  </Button>
                </>
              ) : (
                <>
                  <button
                    className="outline-gradient"
                    onClick={() => setCheckoutStep(1)}
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    <FiChevronLeft size={14} /> Back
                  </button>
                  <Button
                    variant="gradient"
                    icon={<FiCheckCircle />}
                    iconPosition="left"
                    onClick={placeOrder}
                    disabled={stripeLoading}
                  >
                    {stripeLoading ? "Placing Order..." : "Place Order"}
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </UserMasterLayout>
  );
};

export default CustomerCart;
